import { mapState, mapGetters, mapActions } from 'vuex'

export const logListComputed = {
  ...mapState('logList', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('logList', ['getLogList']),
}

export const logListMethods = mapActions('logList', [
  'fetchingLogList',
  'resetLogList',
])
